<template>
  <Modal v-model="show" :mask-closable="false"  @on-ok="save" :loading="loading">
    <div slot="header" class="modal-header">添加供应商</div>
     <form-list ref="addsuppliers" :categoryList="categoryList" :n="n" ></form-list>
  </Modal>
</template>
<script type="text/ecmascript-6">

import { addSupplier } from "api/supplier";
import FormList from './FormItem';

export default {
  props:{
    n:{
      type:Number,
      default:0
    },
    categoryList:{
      type:Array,
      default:[]
    }
  },
  components: {
    FormList
  },
 data () {
 return {
  show:false,
  loading:true
 };
 },
 watch:{
   n(val){
     this.show = true;
     console.log(this.$refs['addsuppliers'])
   }
 },
 methods:{
   changeLoading() {
      this.loading = false;
      this.$nextTick(() => {
          this.loading = true
      })
  },
   save(){
    let params = this.$refs['addsuppliers'].formValidate();
    if(!params){
      this.changeLoading()
      return
    }
    addSupplier(params).then(()=>{
      this.changeLoading()
      this.$Message.success('添加成功');
      this.show=false
      this.$emit('refresh')
    }).catch(error => {
      this.show=true
      this.loading = true
      this.$Message.error('添加失败');
    })
   }
 }
}
</script>
